import React, { useState, useEffect } from 'react';
import '../assets/ProductLoan.css';

const ProductLoan = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    dob: '',
    gender: '',
    phone: '',
    email: '',
    streetAddress: '',
    city: '',
    state: '',
    zip: '',
    previousAddress: '',
    residenceLength: '',
    employer: '',
    jobTitle: '',
    employmentStatus: '',
    employmentLength: '',
    income: '',
    accountNumber: '',
    bankName: '',
    bankIFSC: '',
    assets: '',
    liabilities: '',
    loanAmount: '',
    loanPurpose: '',
    loanTerm: '',
    creditScore: '',
    creditAuthorization: false,
    ref1: '',
    ref2: '',
    maritalStatus: '',
    dependents: '',
    insurance: '',
    signature: '',
    applicationDate: '',
    agreeTerms: false,
    totalAmount: '',
    monthlyEMI: '',
  calculatedMonths: '',
  calculationMode: 'calculateEMI',
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };
  const handleSignatureUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData(prev => ({ ...prev, signature: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  // EMI calculation logic: if totalAmount and monthlyEMI exist and months empty, calculate months;
  // else if totalAmount and months exist and EMI empty, calculate EMI.
useEffect(() => {
  const total = parseFloat(formData.totalAmount);
  const emi = parseFloat(formData.monthlyEMI);
  const months = parseFloat(formData.calculatedMonths);

  if (formData.calculationMode === 'calculateMonths' && total && emi) {
    const calculatedMonths = Math.ceil(total / emi);
    setFormData((prev) => ({
      ...prev,
      calculatedMonths: calculatedMonths.toString(),
    }));
  }

  if (formData.calculationMode === 'calculateEMI' && total && months) {
    const calculatedEMI = total / months;
    setFormData((prev) => ({
      ...prev,
      monthlyEMI: calculatedEMI.toFixed(2),
    }));
  }
}, [
  formData.totalAmount,
  formData.monthlyEMI,
  formData.calculatedMonths,
  formData.calculationMode,
]);




  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Submitted:', formData);
  };

  return (
    <div className="ProductLoanContainer">
      <h2 className="ProductLoanTitle">Product Loan Application</h2>
      <form className="ProductLoanForm" onSubmit={handleSubmit}>

        {/* 1. Personal Information */}
        <fieldset className="ProductLoanSection">
          <legend>1. Personal Information</legend>
          <input
            className="ProductLoanInput"
            name="fullName"
            placeholder="Full Name"
            value={formData.fullName}
            onChange={handleChange}
            required
          />
          <input
            className="ProductLoanInput"
            type="date"
            name="dob"
            value={formData.dob}
            onChange={handleChange}
            required
          />
          <select
            className="ProductLoanInput"
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            required
          >
            <option value="">Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
          <input
            className="ProductLoanInput"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <input
            className="ProductLoanInput"
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </fieldset>

        {/* 2. Address Information */}
        <fieldset className="ProductLoanSection">
          <legend>2. Address Information</legend>
          <input
            className="ProductLoanInput"
            name="streetAddress"
            placeholder="Street Address"
            value={formData.streetAddress}
            onChange={handleChange}
            required
          />
          <input
            className="ProductLoanInput"
            name="city"
            placeholder="City"
            value={formData.city}
            onChange={handleChange}
            required
          />
          <input
            className="ProductLoanInput"
            name="state"
            placeholder="State"
            value={formData.state}
            onChange={handleChange}
            required
          />
          <input
            className="ProductLoanInput"
            name="zip"
            placeholder="ZIP Code"
            value={formData.zip}
            onChange={handleChange}
            required
          />
          <input
            className="ProductLoanInput"
            name="previousAddress"
            placeholder="Previous Address"
            value={formData.previousAddress}
            onChange={handleChange}
          />
          <input
            className="ProductLoanInput"
            name="residenceLength"
            placeholder="Length of Residence (years)"
            value={formData.residenceLength}
            onChange={handleChange}
          />
        </fieldset>

        {/* 3. Employment Information */}
        <fieldset className="ProductLoanSection">
          <legend>3. Employment Information</legend>
          <input
            className="ProductLoanInput"
            name="employer"
            placeholder="Employer Name"
            value={formData.employer}
            onChange={handleChange}
            required
          />
          <input
            className="ProductLoanInput"
            name="jobTitle"
            placeholder="Job Title"
            value={formData.jobTitle}
            onChange={handleChange}
            required
          />
          <select
            className="ProductLoanInput"
            name="employmentStatus"
            value={formData.employmentStatus}
            onChange={handleChange}
            required
          >
            <option value="">Select Employment Status</option>
            <option value="full-time">Full-time</option>
            <option value="part-time">Part-time</option>
            <option value="self-employed">Self-employed</option>
            <option value="unemployed">Unemployed</option>
          </select>
          <input
            className="ProductLoanInput"
            name="employmentLength"
            placeholder="Length of Employment (years)"
            value={formData.employmentLength}
            onChange={handleChange}
            required
          />
          <input
            className="ProductLoanInput"
            name="income"
            placeholder="Monthly Income"
            value={formData.income}
            onChange={handleChange}
            required
          />
        </fieldset>

        {/* 4. Financial Information */}
        <fieldset className="ProductLoanSection">
          <legend>4. Financial Information</legend>
          <input
            className="ProductLoanInput"
            name="accountNumber"
            placeholder="Bank Account Number"
            value={formData.accountNumber}
            onChange={handleChange}
            required
          />
          <input
            className="ProductLoanInput"
            name="bankName"
            placeholder="Bank Name"
            value={formData.bankName}
            onChange={handleChange}
            required
          />
          
          <input
            className="ProductLoanInput"
            type="text"
            name="bankIFSC"
            placeholder="Enter Bank IFSC Code"
            value={formData.bankIFSC}
            onChange={handleChange}
            required
          />
          <textarea
            className="ProductLoanInput ProductLoanTextarea"
            name="assets"
            placeholder="List Your Assets"
            value={formData.assets}
            onChange={handleChange}
          />
          <textarea
            className="ProductLoanInput ProductLoanTextarea"
            name="liabilities"
            placeholder="List Your Liabilities"
            value={formData.liabilities}
            onChange={handleChange}
          />
        </fieldset>

        {/* 5. Loan Details */}
        <fieldset className="ProductLoanSection">
          <legend>5. Loan Details</legend>
          <input
            className="ProductLoanInput"
            name="loanAmount"
            placeholder="Loan Amount Requested"
            value={formData.loanAmount}
            onChange={handleChange}
            required
          />
          <input
            className="ProductLoanInput"
            name="loanPurpose"
            placeholder="Purpose of Loan"
            value={formData.loanPurpose}
            onChange={handleChange}
            required
          />
          <input
            className="ProductLoanInput"
            name="loanTerm"
            placeholder="Preferred Loan Term (months)"
            value={formData.loanTerm}
            onChange={handleChange}
            required
          />
        </fieldset>

        {/* 6. Credit Information */}
        <fieldset className="ProductLoanSection">
          <legend>6. Credit Information</legend>
          <input
            className="ProductLoanInput"
            name="creditScore"
            placeholder="Credit Score (optional)"
            value={formData.creditScore}
            onChange={handleChange}
          />
          <label className="ProductLoanCheckboxLabel">
            <input
              type="checkbox"
              name="creditAuthorization"
              checked={formData.creditAuthorization}
              onChange={handleChange}
              required
            />
            I authorize Techvision to perform a credit check.
          </label>
        </fieldset>

        {/* 7. References */}
        <fieldset className="ProductLoanSection">
          <legend>7. References</legend>
          <input
            className="ProductLoanInput"
            name="ref1"
            placeholder="Reference 1 (Name & Contact)"
            value={formData.ref1}
            onChange={handleChange}
          />
          <input
            className="ProductLoanInput"
            name="ref2"
            placeholder="Reference 2 (Name & Contact)"
            value={formData.ref2}
            onChange={handleChange}
          />
        </fieldset>

        {/* 8. Additional Information */}
        <fieldset className="ProductLoanSection">
          <legend>8. Additional Information</legend>
          <select
            className="ProductLoanInput"
            name="maritalStatus"
            value={formData.maritalStatus}
            onChange={handleChange}
            required
          >
            <option value="">Select Marital Status</option>
            <option value="single">Single</option>
            <option value="married">Married</option>
            <option value="divorced">Divorced</option>
          </select>
          <input
            className="ProductLoanInput"
            name="dependents"
            placeholder="Number of Dependents"
            value={formData.dependents}
            onChange={handleChange}
          />
          <textarea
            className="ProductLoanInput ProductLoanTextarea"
            name="insurance"
            placeholder="Relevant Insurance Info"
            value={formData.insurance}
            onChange={handleChange}
          />
        </fieldset>

        {/* 9. Signature and Date */}
        <fieldset className="ProductLoanSection">
          <legend>Applicant Signature</legend>

          <label htmlFor="signatureUpload">Upload Signature:</label>
          <input
            id="signatureUpload"
            className="ProductLoanInput"
            type="file"
            accept="image/*"
            onChange={handleSignatureUpload}
            required
          />
          <input
            className="ProductLoanInput"
            type="date"
            name="applicationDate"
            value={formData.applicationDate}
            onChange={handleChange}
            required
          />
        </fieldset>

        {/* 10. Disclosures and Agreements */}
        <fieldset className="ProductLoanSection">
          <legend>10. Disclosures and Agreements</legend>
          <textarea
            className="ProductLoanInput ProductLoanTextarea"
            name="terms"
            readOnly
            value="Interest rates, fees, penalties apply. Please read carefully."
          />
          <textarea
            className="ProductLoanInput ProductLoanTextarea"
            name="privacy"
            readOnly
            value="We value your privacy and protect your data."
          />
          <label className="ProductLoanCheckboxLabel">
            <input
              type="checkbox"
              name="agreeTerms"
              checked={formData.agreeTerms}
              onChange={handleChange}
              required
            />
            I agree to the terms and privacy policy.
          </label>
        </fieldset>

        {/* 11. EMI Calculation */}
        <fieldset className="ProductLoanSection">
  <legend>11. EMI Calculation</legend>

  {/* Mode Selector */}
  <label className="ProductLoanLabel">Select Calculation Mode:</label>
  <div className="ProductLoanRadioGroup">
  <input
    type="radio"
    id="calculateEMI"
    name="calculationMode"
    value="calculateEMI"
    checked={formData.calculationMode === 'calculateEMI'}
    onChange={handleChange}
  />
  <label htmlFor="calculateEMI">Calculate Monthly EMI</label>

  <input
    type="radio"
    id="calculateMonths"
    name="calculationMode"
    value="calculateMonths"
    checked={formData.calculationMode === 'calculateMonths'}
    onChange={handleChange}
  />
  <label htmlFor="calculateMonths">Calculate Number of Months</label>
</div>


  <label className="ProductLoanLabel" htmlFor="totalAmount">Total Loan Amount:</label>
  <input
    id="totalAmount"
    className="ProductLoanInput"
    type="number"
    name="totalAmount"
    placeholder="Enter Total Loan Amount"
    value={formData.totalAmount}
    onChange={handleChange}
  />

  <label className="ProductLoanLabel" htmlFor="monthlyEMI">Monthly EMI in ₹:</label>
  <input
    id="monthlyEMI"
    className="ProductLoanInput"
    type="number"
    name="monthlyEMI"
    placeholder="Enter Monthly EMI"
    value={formData.monthlyEMI}
    onChange={handleChange}
    disabled={formData.calculationMode === 'calculateEMI'}
  />

  <label className="ProductLoanLabel" htmlFor="calculatedMonths">Number of Months:</label>
  <input
    id="calculatedMonths"
    className="ProductLoanInput"
    type="number"
    name="calculatedMonths"
    placeholder="Enter Number of Months"
    value={formData.calculatedMonths}
    onChange={handleChange}
    disabled={formData.calculationMode === 'calculateMonths'}
  />
</fieldset>


        <button type="submit" className="ProductLoanSubmitBtn">Submit Application</button>
      </form>
    </div>
  );
};

export default ProductLoan;
